export * from './abi'
export * from './tokens'
export * from './time'

export const TIP_REACT_KEY = 'tip_key'

export const API_KEY = 'TEST' //'key_48AiZQ7jeDMfaJkN5TzJ5L'
